import React from 'react';
import cn from 'classnames';
import { IconButton } from 'seagull';
import { Checkmark } from 'seagull/icons';
import styles from "./ColorSelector.module.scss";
/**
 * Renders a clickable circle filled with a specified color with an optional checked icon
 * to signify the color is selected.
 */
export function ColorSelector(props) {
  const {
    color,
    selected,
    disabled,
    withBorder,
    hasError,
    testid,
    onClick
  } = props;
  return /*#__PURE__*/React.createElement(IconButton, {
    className: cn(withBorder && styles.border, hasError && styles.hasError),
    skin: "transparent",
    size: "small",
    noPadding: true,
    disabled: disabled,
    "data-testid": testid,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.circle, {
      [styles.selected]: selected
    }),
    style: {
      background: color
    }
  }, selected && /*#__PURE__*/React.createElement("div", {
    className: styles.checked,
    "data-testid": testid && "".concat(testid, "-checked")
  }, /*#__PURE__*/React.createElement(Checkmark, {
    width: "16",
    height: "16"
  }))));
}